import { Promise } from '../promise';
export default ((iterable, reducer, initial) => iterable.reduce((promise, ...rest) => promise.then(resolved => Promise.resolve(reducer(resolved, ...rest))), Promise.resolve(initial)));